import { xchacha20poly1305 } from '@noble/ciphers/chacha'
import { randomBytes } from './random'

const NONCE_LEN = 24

export async function encrypt(plaintext: Uint8Array, key: Uint8Array): Promise<Uint8Array> {
  const nonce = randomBytes(NONCE_LEN)
  const cipher = xchacha20poly1305(key, nonce)
  const ct = cipher.encrypt(plaintext)
  const out = new Uint8Array(nonce.length + ct.length)
  out.set(nonce, 0)
  out.set(ct, nonce.length)
  return out
}

export async function decrypt(blob: Uint8Array, key: Uint8Array): Promise<Uint8Array> {
  const nonce = blob.subarray(0, NONCE_LEN)
  const ct = blob.subarray(NONCE_LEN)
  const cipher = xchacha20poly1305(key, nonce)
  return cipher.decrypt(ct)
}

export async function encryptJSON(value: unknown, key: Uint8Array): Promise<Uint8Array> {
  const json = JSON.stringify(value)
  const bytes = new TextEncoder().encode(json)
  return encrypt(bytes, key)
}

export async function decryptJSON<T = unknown>(blob: Uint8Array, key: Uint8Array): Promise<T> {
  const bytes = await decrypt(blob, key)
  const json = new TextDecoder().decode(bytes)
  return JSON.parse(json) as T
}
